import { Grid, TextField } from '@material-ui/core';
import moment from 'moment';
import React, {useEffect, useMemo, useState} from 'react';
import {useQueryClient} from "react-query";

import { CheckboxEditor, ComboSelect, DatePicker, FormDialog, FormSelect, MaskedNumber, MaskedTime }from "../../../../controls";
import { useAddNote, useNotes, useUpdateNote } from '../../../../services/notes';
import DelayCodeLookup from '../../../Settings/components/DelayCodeLookup';
import Validator from "../../validators/TripLegEventValidator";
import { MovementTimes } from "../../../Trips/components/TripListDialogs/MovementsTooltip";

const TripLegEventDialog = (props) => {

  const classes = props.classes;
  const SystemData = props.systemData;
  const queryClient = useQueryClient();
  const eventBus = SystemData.eventBus;

  const [dialogState, setDialogState] = useState({
    showDialog: false,
    canEdit: false,
    tripLegUuid: null,
    noteType: "TRIP_LEG:FLIGHT_EVENT",
    noteUuid: null,
    title: 'Flight Event',
    tripData: {},
    std: null,
    etd: null,
    delayed: false,
    stdMinutes: 0,
    etdMinutes: 0,
    delayedUntil: null
  });

  const DisplayForm = () => {
    const extraKeys = [dialogState.noteUuid||'']
    const note = useNotes({queryClient, extraKeys});
    const handleAddNote = useAddNote();
    const handleUpdateNote = useUpdateNote();
    const std = moment(dialogState.std);
    const etd = dialogState.etd?moment(dialogState.etd):null;

    const offsetOptions = dialogState.etd && (!dialogState.delayed || dialogState.etdMinutes>0)?[
      {code: "ETD", value: "ETD"},
      {code: "STD", value: "STD"}
    ]:[
      {code: "STD", value: "STD"}
    ]
    
    if ((note && Array.isArray(note.data) && note.data.length > 0 ) || !dialogState.noteUuid) {
      return (
        <FormDialog
          title={dialogState.title}
          message=""
          open={dialogState.showDialog}
          record={!dialogState.noteUuid ? dialogState.delayed?{primaryObjectUuid: dialogState.tripLegUuid, noteType: dialogState.noteType, delayRequired: true, delayCode: "", delayOffsetFrom: dialogState.delayOffsetFrom, delayMinutes: dialogState.delayOffsetFrom==='ETD'?dialogState.etdMinutes:dialogState.stdMinutes, delayedUntil: dialogState.delayedUntil, delayApplied: true}:{primaryObjectUuid: dialogState.tripLegUuid, noteType: dialogState.noteType, delayRequired: true, delayCode: "", delayOffsetFrom: "", delayMinutes: 0, delayedUntil: dialogState.etd || dialogState.std, delayApplied: true} : note.data[0]}
          dialogOptions={{maxWidth: "sm", fullWidth: false}}
          classes={classes}
          validator={Validator}
          buttons = {{
            save:{icon: "check_circle", key: "Update", label: "Update", color: "primary", disabled: (status)=>{return status.error}},
            cancel:{icon: "cancel", key: "Cancel", label: "Cancel", color: "primary"}
          }}
          onChange={(state) => {
            if (state.buttonPressed === "save") {
              const record = state.record;
              record.delayApplied = true;

              const saveRecord = (record) => {
                if (dialogState.noteUuid) {
                  handleUpdateNote.mutate({
                    record,
                    extraKeys,
                    resolve: () => {
                      setDialogState({ ...dialogState, showDialog: false, record: null, handleSave: null });
                      if (props.afterSave) {
                        props.afterSave();
                      }
                      if (typeof props.onClose === 'function') {props.onClose()}
                    },
                    reject: (err) => {
                      SystemData.openAlert("Error Saving Event", "An unexpected error has occurred while saving the event.");
                    }
                  });
                } else {
                  handleAddNote.mutate({
                    record,
                    extraKeys,
                    resolve: () => {
                      setDialogState({ ...dialogState, showDialog: false, record: null, handleSave: null });
                      if (props.afterSave) {
                        props.afterSave();
                      }
                      if (typeof props.onClose === 'function') {props.onClose()}
                    },
                    reject: (err) => {
                      SystemData.openAlert("Error Saving Event", "An unexpected error has occurred while saving the event.");
                    }
                  });
                }
              }
              if (dialogState.etd && moment.utc(record.delayedUntil).isBefore(moment.utc(dialogState.etd))) {
                SystemData.confirm(
                  "Apply Delay to Flight",
                  "The new delay is before the current ETD, do you wish to Update the ETD?",
                  [
                    {icon: "check_circle", value: true, label: "Update Estimated Date", options: {color:"primary"}},
                    {icon: "note", value: false, label: "Information Only", options: {color:"primary"}},
                    {icon: "cancel", value: null, label: "Cancel", options: {color:"secondary"}}
                  ],
                  async (response) => {  
                    if (response === null) {
                      setDialogState({...dialogState, showDialog: false, record: null, handleSave: null});
                      if (typeof props.onClose === 'function') {props.onClose()}
                    } else {
                      record.delayApplied = response;
                      saveRecord(record);
                    }
                  }
                );            
              } else {
                saveRecord(record);
              }
            } else {
              setDialogState({...dialogState, showDialog: false, record: null, handleSave: null});
              if (typeof props.onClose === 'function') {props.onClose()}
            }
          }}
        >
          <div style={{display: "inline-block", width: 400}} checkChildren={true}>
            <Grid container checkChildren={true} spacing={3} >{/*style={{width: "calc(100% + 36px"}}*/}
              <Grid item xs={12} checkChildren={true}>
                <MovementTimes classes={classes} data={dialogState.tripData} showScheduled={true}/>
              </Grid>
              {/* <Grid item xs={2} checkChildren={true}>
                <CheckboxEditor
                  id="delayRequired"
                  label="Delayed"
                  readOnly={dialogState.delayed}
                  onChange={(value, props) => {
                    if (value === false) {
                      props.recordChange({...props.record, delayOffsetFrom: "", delayRequired: value, delayCode: "", delayMinutes: null, delayedUntil: dialogState.delayedUntil || dialogState.etd || dialogState.std, delayApplied: null})
                    } else {
                      props.recordChange({...props.record, delayOffsetFrom: dialogState.etd?"ETD":"STD", delayRequired: value, delayCode: "", delayMinutes: 0, delayedUntil: dialogState.delayedUntil || dialogState.etd || dialogState.std, delayApplied: null})
                    }
                  }}
                />
              </Grid> */}
              <Grid item xs={3} checkChildren={true}>
                {(record) => (
                  <DelayCodeLookup
                    id="delayCode"
                    label="Delay Code"
                    inputLabelProps={{ shrink: true }}
                    // disabled={!record.delayRequired}
                    // readOnly={!record.delayRequired}
                  />
                )}
              </Grid>
              <Grid item xs={7} checkChildren={true}>
              </Grid>
              <Grid item xs={3} checkChildren={true}>
                {(record) => (
                  <FormSelect
                    id="delayOffsetFrom"
                    label="Offset From"
                    value={record.delayOffsetFrom}
                    options={offsetOptions}
                    // disabled={!record.delayRequired}
                    // readOnly={!record.delayRequired}
                    onChange={(value, props) => {
                      props.recordChange({...props.record, delayOffsetFrom: value, delayMinutes: dialogState.delayed?(value==="ETD"?dialogState.etdMinutes:dialogState.stdMinutes):0, delayedUntil: dialogState.delayedUntil || value==="ETD"?dialogState.etd:dialogState.std})
                    }}
                  />
                )}
              </Grid>                
              <Grid item xs={3} checkChildren={true}>
                {(record) => (
                  <MaskedNumber
                    id="delayMinutes"
                    label="Duration (mins)"
                    inputLabelProps={{ shrink: true }}
                    decimalScale={0}
                    fixedDecimalScale={true}
                    format="####"
                    // disabled={!record.delayRequired}
                    // readOnly={!record.delayRequired || dialogState.delayed}
                    readOnly={dialogState.delayed}
                    onChange={(value, props) => {
                      if (!isNaN(value)) {
                        const delayedUntil = record.delayOffsetFrom==="ETD"?moment(etd).add(value, 'minutes'):moment(std).add(value, 'minutes');
                        props.recordChange({...props.record, delayMinutes: value, delayedUntil: delayedUntil})
                      } else {
                        props.onChange(value);
                      }
                    }}
                  />          
                )}
              </Grid>
              <Grid item xs={6} checkChildren={true}>
                {(record) => (
                  <div>
                    <div style={{position: "relative", display: "inline-block", width: "65%"}}>
                      <DatePicker
                        id="delayedUntil"
                        label="New ETD"
                        autoOk={true}
                        value={record.delayedUntil}
                        minDate={ moment(dialogState.std).startOf('day')}
                        inputLabelProps={{ shrink: true }}
                        // disabled={!record.delayRequired}
                        // readOnly={!record.delayRequired || dialogState.delayed}
                        readOnly={dialogState.delayed}
                        onChange={(value, props) => {
                          const estimatedMoment = moment(record.delayedUntil);
                          const newDate = moment(value).startOf('day');
                          const hh = estimatedMoment.get('hour');
                          const mm = estimatedMoment.get('minute');
                          const delayedUntil = moment(newDate).set('hour', hh).set('minute', mm);
                          if (delayedUntil.isValid()) {
                            const delayMinutes = delayedUntil.diff(record.delayOffsetFrom==="ETD"?etd:std, 'minutes');
                            props.recordChange({...props.record, delayMinutes, delayedUntil: delayedUntil.toISOString()})
                          } else {
                            props.onChange(value);
                          }
                        }}
                      />      
                    </div> 
                    <div style={{position: "relative", display: "inline-block", width: "calc(35% - 5px)", paddingLeft: 5, top: -6.5}}>
                      <MaskedTime
                        id="delayedUntil"
                        label=" "
                        value={record.delayedUntil}
                        source="timestamp"
                        inputLabelProps={{ shrink: true }}
                        // disabled={!record.delayRequired}
                        // readOnly={!record.delayRequired || dialogState.delayed}
                        readOnly={dialogState.delayed}
                        onChange={(value, props) => {
                          const delayedUntil = moment.utc(value);
                          if (value.length === 19 && delayedUntil.isValid()) {
                            const delayMinutes = delayedUntil.diff(record.delayOffsetFrom==="ETD"?etd:std, 'minutes');
                            props.recordChange({...props.record, delayMinutes, delayedUntil: delayedUntil.toISOString()})
                          }
                        }}
                      />   
                    </div>       
                  </div>   
                )}
              </Grid>
              <Grid item xs={12} checkChildren={true}>
                <TextField
                  id="noteText"
                  label="Delay Reason"
                  placeholder="Flight delay reason"
                  multiline
                  variant="outlined"
                />
              </Grid>
              {/* <Grid item xs={12} checkChildren={true}>
                {record => (
                  <ComboSelect 
                    id="delayApplied"
                    label="Delay Action"
                    group="DELAY ACTIONS"
                    subGroup=""
                    inputLabelProps={{ shrink: true }}
                    disabled={!record.delayRequired}
                    readOnly={!record.delayRequired || dialogState.delayed}
                  />
                )}
              </Grid> */}
            </Grid>
          </div>
        </FormDialog>
      )
    } else {
      return <></>;
    }
  }

  useEffect(()=> {
    const open = async (params) => {
      //TODO: tripLegUuid should be primaryObjectUuid as it can be either tripLegUuid or tripUuid
      const {title, canEdit, tripLegUuid, noteType, noteUuid, tripData} = params;
      setDialogState({...dialogState, showDialog:true, canEdit, title, tripLegUuid, noteType, noteUuid, tripData, etd: tripData?.etd, std: tripData?.std, delayed: params.delayed||false, stdMinutes: params.stdMinutes, etdMinutes: params.etdMinutes, delayOffsetFrom: params.etdMinutes?'ETD':params.stdMinutes?'STD':'', delayedUntil: params.delayedUntil});
    }
    eventBus.bind("TripLegEventDialog.open", open);
    return () => {
      eventBus.unbind("TripLegEventDialog.open", open);
      queryClient.invalidateQueries("Notes");
    }
  }, [dialogState, eventBus, queryClient]);

  if (dialogState.showDialog) {
    return (
      <DisplayForm />
    )
  }
  return (<></>);
}

export default TripLegEventDialog;
